import { useEffect, useState } from 'react';
import moment from 'moment';

import { getProjectRevenue, getProjectRevenueList } from '../../api/constlink';
import RevenueDetailDrawer from './RevenueDetailDrawer';
import RevenueListComponent from '../../components/revenues/RevenueListComponent';

interface RevenueListContainerProps {
  enterpriseId: string;
}

function RevenueListContainer({ enterpriseId }: RevenueListContainerProps) {
  const [revenueList, setRevenueList] = useState<any>();
  const [revenue, setRevenue] = useState<any>();

  useEffect(() => {
    (async () => {
      const data = await getProjectRevenueList({ enterpriseId });
      setRevenueList(data);
    })();
  }, [enterpriseId]);

  const moveToDetailPage = async (data: any) => {
    (async () => {
      const res = await getProjectRevenue({ enterpriseId, projectId: data.id });
      setRevenue(res);
    })();
  };

  const onSearch = async (values: any) => {
    const filter: any = {};
    if ('name' in values && values.name !== undefined && values.name !== '')
      filter.name = values.name;
    if (
      'status' in values &&
      values.status !== undefined &&
      values.status !== ''
    )
      filter.status = values.status;
    if ('owner' in values && values.owner !== undefined && values.owner !== '')
      filter.owner = values.owner;

    if (
      'firstDate' in values &&
      values.firstDate !== undefined &&
      values.firstDate !== null
    )
      filter.firstDate = moment(values.firstDate).format('YYYY-MM-DD');

    if (
      'lastDate' in values &&
      values.lastDate !== undefined &&
      values.lastDate !== null
    )
      filter.lastDate = moment(values.lastDate).format('YYYY-MM-DD');

    const data = await getProjectRevenueList({ enterpriseId, filter });
    setRevenueList(data);
  };

  return (
    <>
      {revenueList && (
        <RevenueListComponent
          data={revenueList}
          moveToDetailPage={moveToDetailPage}
          onSearch={onSearch}
        />
      )}
      {
        <RevenueDetailDrawer
          projectRevenue={revenue}
          visibleDetailDrawer={!!revenue}
          enterpriseId={enterpriseId}
          onClose={() => {
            setRevenue(null);
            (async () => {
              const data = await getProjectRevenueList({ enterpriseId });
              setRevenueList(data);
            })();
          }}
          updateRevenue={(incomes: any[]) => {
            setRevenue({ ...revenue, incomes });
          }}
        />
      }
    </>
  );
}

export default RevenueListContainer;
